import type { RemoveJobSeekerProfileStructuredDataInput } from "../../../../../../../../__generated__/types.gqlgenerated";
import type { QualificationAttribute } from "../../../types/JobAttribute";

import { useRemoveJobSeekerProfileStructuredDataMutation } from "./__generated__/useRemoveJobSeekerProfileStructuredData.gqlgenerated";
import { getRequirementIds } from "./getRequirementIds";

import { useCallback } from "react";

export function useRemoveJobSeekerProfileStructuredData() {
  const [removeJobSeekerProfileStructuredDataMutation] =
    useRemoveJobSeekerProfileStructuredDataMutation();
  return useCallback(
    async (attribute: QualificationAttribute, ids: string[]) => {
      const attributeIds = getRequirementIds(attribute.type, ids);
      const attributesInput: RemoveJobSeekerProfileStructuredDataInput = attributeIds;
      const { data } = await removeJobSeekerProfileStructuredDataMutation({
        variables: { input: attributesInput },
      });

      if (!data || !data.removeJobSeekerProfileStructuredData) {
        throw new Error("Null response received from JSSD");
      }

      return data.removeJobSeekerProfileStructuredData;
    },
    [removeJobSeekerProfileStructuredDataMutation],
  );
}
